module.exports = __webpack_public_path__ + "static/1.1_the_tools_of_history-70fce1849c1252037ffefd517b41a12c.pdf";